import { render, staticRenderFns } from "./add.vue?vue&type=template&id=c0416042&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=c0416042&prod&lang=css"
import style1 from "./add.vue?vue&type=style&index=1&id=c0416042&prod&lang=scss&scoped=true"
import style2 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0416042",
  null
  
)

export default component.exports